// src/components/dashboard/widgets/public-holiday-widget.tsx
import { useEffect, useState } from 'react';
import { PartyPopper } from 'lucide-react';
import { supabase } from '@/src/lib/supabase';
import { useAppColors } from '@/src/lib/theme';

interface HolidayData { name: string; date: string }

function daysUntil(dateStr: string): number {
  const target = new Date(`${dateStr}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86400000);
}

function formatLabel(days: number): string {
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  return `In ${days} days`;
}

export default function PublicHolidayWidget() {
  const c = useAppColors();
  const [holidays, setHolidays] = useState<HolidayData[] | undefined>(undefined);

  useEffect(() => {
    supabase.functions.invoke('next-holiday').then(({ data }) => {
      setHolidays(data?.holidays ?? []);
    });
  }, []);

  return (
    <div className="rounded-2xl border p-4 bg-warm-gray border-leaf-500/20 h-full">
      <div className="flex items-center justify-between mb-3">
        <div className="w-8 h-8 rounded-lg bg-leaf-500/10 flex items-center justify-center">
          <PartyPopper size={15} className="text-leaf-400" />
        </div>
        <span className="text-[9px] font-bold tracking-widest text-cream-muted/50 uppercase">public holidays</span>
      </div>
      {holidays === undefined ? (
        <div className="text-xs text-cream-muted/50">Loading…</div>
      ) : holidays.length === 0 ? (
        <div className="text-xs text-cream-muted/50">None coming up</div>
      ) : (
        <div className="space-y-1.5">
          {holidays.map((h) => (
            <div key={h.date} className="flex items-center justify-between gap-2">
              <span className="text-xs text-cream truncate">{h.name}</span>
              <span className="text-[10px] text-cream-muted flex-shrink-0">{formatLabel(daysUntil(h.date))}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}